module.exports = __webpack_public_path__ + "img/spotr.989614b7.svg";